export var SELECT_EVENT_TYPE = 'SELECT_EVENT_TYPE';
export var selectEventType = function selectEventType(selectedEventType) {
  return {
    type: SELECT_EVENT_TYPE,
    selectedEventType: selectedEventType
  };
};